import { SET_SHIFT } from '../constants'

export default function SetShift(shift = {}) {
  return {
    type: SET_SHIFT,
    shift,
  }
}
